import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * shadcn/ui's class merger. `clsx` resolves conditionals, `tailwind-merge` drops the
 * losing half of a conflicting pair so a caller's `className` always wins over a
 * component's default without either side knowing about the other.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
